/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { Card, Button } from "@forge/common";
export interface FooterProps {
  cancelButtonRequired: boolean;
  cancelBtnLabel?: string;
  openDialogCancel: boolean;
  setOpenDialogCancel(value: boolean): void;
  openDialogonClose: boolean;
  createBtnLabel?: string;
  openDialogCreate: boolean;
  openDialogCreateHeading?: string;
  openDialogCreateContent?: string;
  dialogCreatePrimaryBtnLabel?: string;
  dialogCreateSecondaryBtnLabel?: string;
  setOpenDialogCreate(value: boolean): void;
  onSubmit(): void;
  onBackBtn?: () => void;
  checkIfAnyTextFilled(): any;
  validate(): any;
  disableSave?: boolean;
}

const Footer = (props: FooterProps) => {
  // Footer dialog component
  // Use it in return statement to render dialog related to footer
  // istanbul ignore next
  // Pass props to dialog component
  const dialogComponent = (
    <Dialog
      open={props.openDialogCreate}
      onClose={() => props.setOpenDialogCreate(false)}
    >
      {/* //openDialog //openDialogonCLose */}
      <DialogTitle className="dialogHeading" id="dialog-title">
        {props?.openDialogCreateHeading}
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => props.setOpenDialogCreate(false)}
          aria-label="close"
          sx={{ marginLeft: "auto" }}
        >
          <CloseIcon />
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="dialogInfo">
          {props?.openDialogCreateContent}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingRight: 4,
          paddingBottom: 4,
        }}
      >
        <Button
          variant="secondary"
          onClick={() => props.setOpenDialogCreate(false)}
        >
          {props.dialogCreateSecondaryBtnLabel} {/* Cancel */}
        </Button>
        <Button onClick={props.onSubmit}>
          {props.dialogCreatePrimaryBtnLabel} {/* Create */}
        </Button>
      </DialogActions>
    </Dialog>
  );
  //
  return (
    <Card className="footer footer_singleButton">
      <Button
        size="regular"
        variant="quiet-primary"
        className="cursor-pointer"
        data-testid="cancelBtn"
        onClick={props.onBackBtn}
        disabled={!props.cancelButtonRequired}
        aria-label="cancel"
      >
        {props.cancelBtnLabel ? props.cancelBtnLabel : "Cancel"}
      </Button>

      <Button
        data-testid="submitBtn"
        size="regular"
        variant="primary"
        className="cursor-pointer"
        {...(props.checkIfAnyTextFilled() && {
          disabled: false,
        })}
        onClick={() => props.validate()}
        aria-label="create"
        disabled={props.disableSave}
      >
        {props.createBtnLabel ? props.createBtnLabel : "Create"}
      </Button>
      {dialogComponent}
    </Card>
  );
};
/// end return Dialog

export default Footer;
